<template>
  <div style="height: 1px; background-color: #80808040"></div>
</template>
